import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'lms-course-item',
  templateUrl: './course-item.component.html',
  styleUrls: ['./course-item.component.scss']
})
export class CourseItemComponent implements OnInit {
  @Input() course: any;
  @Output() deleteCourse = new EventEmitter<any>();
  @Input() hideButtons?: boolean;
  @Input() unavailableCourse: boolean;
  public imageUrl: string;
  public bannerMobilePosition: number;

  constructor() {}

  ngOnInit() {
    this.imageUrl =
      this.course.bannerUrl || this.course.cardImageUrl
        ? `${environment.RESOURCES_HOST}${this.course.bannerUrl ? this.course.bannerUrl : this.course.cardImageUrl}`
        : null;
    this.bannerMobilePosition = this.getBannerMobilePosition();
  }
  delete() {
    this.deleteCourse.emit();
  }

  getBannerMobilePosition() {
    const widthImage = 87; //image size box admin (only desktop)
    const widthImageEditor = 292; //image size box editor
    const bannerMobilePosition = this.course.bannerMobilePosition
      ? Math.trunc((widthImage * this.course.bannerMobilePosition) / widthImageEditor) // proportional size
      : 0;
    return bannerMobilePosition;
  }
}
